module.exports = __webpack_public_path__ + "static/media/umbrella-black.fb1036b7.png";